// request.js文件
import axios from 'axios';
import store from '../store/store';
import router from '../router';
import { Toast,Dialog } from 'vant';
// 引入基础参数文件  和  baseURL配置文件
// import { BASE_URL } from './config'   // baseURL写在config.js文件中
const request = axios.create({
  baseURL: window.glob.baseURL,
  timeout: 10000
});
// 添加请求拦截器
request.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    config.headers = {
      Authorization: store.state.m_user.token
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.data.code == 401) {
      Dialog.confirm({
        title: '温馨提示',
        message: '身份过期或未登录,请重新登录！'
      })
        .then(() => {
          router.push('/login');
        
        })
        .catch(() => {
          // on cancel
            //点取消回首页
           router.push('/');
              
        });
    }

    if (response.data.code == 500) {
      Toast.fail(response.data.msg)
    }
    return response;
  },
  
  function (error) {
    // 对请求错误做些什么
    let { message } = error;

    if (message == 'Network Error') {
      // loadingInstance.close();
      message = '后端接口连接异常';
    } else if (message.includes('timeout')) {
      // loadingInstance.close();
      message = '系统接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      // loadingInstance.close();
      message = '系统接口' + message.substr(message.length - 3) + '异常';
    }
    Toast.fail({
      message: message,
      duration: 3 * 1000
    });
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default request;
